<template>
    <footer class="social">
        <div class="container">
            <div class="social__title">
                Suivez-nous
            </div>

            <ul class="social__menu">
                <slot></slot>
            </ul>
        </div>
    </footer>
</template>

<script>
    export default {
        name: 'LayoutSocial',

        data () {
            return {};
        },
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_placeholders';
    @import '~@/assets/styles/abstracts/_mixins';

    .social {
        background: $color-brand;
        color:      $white;

        padding:    4.1rem 1.5rem 3.8rem;

        &__title {
            @extend %font-OpenSans-bold;

            font-size: 2.2rem;
        }

        &__menu {
            display:     flex;
            align-items: center;

            position:    relative;
            left:        -2.3rem;

            margin:      0;
            padding:     0;

            list-style:  none;
        }

        &__link {
            @include text-hide();

            display:         flex;
            justify-content: center;
            align-items:     center;

            color:           inherit;

            @include size(6rem, 5rem);

            &::after {
                @include size(100%, 100%);
                content:         '';

                background:      no-repeat center;
                background-size: 50%;
            }

            &--facebook::after {
                background-image: url('~@/assets/images/facebook.png');
            }
            &--twitter::after {
                background-image: url('~@/assets/images/twitter.png');
            }
            &--linkedin::after {
                background-image: url('~@/assets/images/linkedin.png');
            }
            &--instagram::after {
                background-image: url('~@/assets/images/instagram.png');
            }
        }

        @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
            padding-left:  0;
            padding-right: 0;

            &__title {
                text-align: center;
            }

            &__menu {
                position:        static;
                left:            auto;

                justify-content: center;
            }

            &__faciliti {
                text-align: center;
            }
        }
    }
</style>
